import { render, staticRenderFns } from "./mortgageList.vue?vue&type=template&id=01b08daa&scoped=true&lang=html&"
import script from "./mortgageList.vue?vue&type=script&lang=js&"
export * from "./mortgageList.vue?vue&type=script&lang=js&"
import style0 from "./mortgageList.vue?vue&type=style&index=0&id=01b08daa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b08daa",
  null
  
)

export default component.exports